import { forwardRef, Ref, type SVGProps } from 'react';

const SvgWoodland = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      fill="#033532"
      d="m12.552 1.5 1.087 5.442 1.331.041-1.615 2.831 2.259-.77 3.412-.306-2.11 4.93-3.205 1.568s1.29 1.557 1.147 1.549-5.617 1.655-5.617 1.655l-.998-1.035-.261 2.095-1.719-.516.895-1.926-1.456.322s-3.6-4.384-3.723-4.455c-.122-.072 1.83-.657 1.83-.657L2.036 9.207l1.042-5.25 2.66 2.125 1.44 1.88.262-3.237 1.129.697z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgWoodland);
export default ForwardRef;
